module.exports = __webpack_public_path__ + "static/img/br.8bcede61.svg";